<template>
    <div class='chart-container bg-white w-full flex row w-full p-20' :class="companyData.company_type">
        <!-- <canvas id="acquisitions"></canvas> -->
        <div class="chart-section pointer" style="flex: 10;">
            <div class="section-header text-left">Document Completetion Progress</div>
            <div class="completion-rate-info text-left"><span class="bold counts-color"> {{ total_documents_filled }} / {{ total_documents_needed }}</span><div class="info-text">documents complete</div></div>
        </div>
        <div class="chart-section pointer" style="flex: 7;" @click="showRediness = 'corporate'" v-if="companyData.company_type == 'corporate'">
            <div class="wrapper-icon">
                <img src="@/assets/arrow_1.svg" class="arrow">
            </div>
            <div class="element-ch">
                <apexchart class="chart-element" type="donut" :options="getOptions('general').options" :series="generalSection"></apexchart>
                <div class="section-description">
                    <div class="section-title">Corporate Section Progress</div>
                    <div class="section-details"><span class="counts counts-color">{{ filledDocsGeneral.filledDocuments }} / {{ filledDocsGeneral.needed_docs }}</span> documents complete</div>
                </div>
            </div>
        </div>
        <div class="dividor"></div>
        <div class="chart-section  pointer" style="flex: 7;" @click="showRediness = 'shareholders'">
            <div class="wrapper-icon">
                <img src="@/assets/arrow_1.svg" class="arrow">
            </div>
            <div class="element-ch">
                <apexchart class="chart-element" type="donut" :options="getOptions('sh').options" :series="shareholderSeries"></apexchart>
                <div class="section-description">
                    <div class="section-title">{{ getTitle }}</div>
                    <div class="section-details"><span class="counts counts-color">{{ initShareholderCheck.filled }} / {{ initShareholderCheck.needed }}</span> documents complete</div>
                </div>
            </div>
        </div>
        <div class="dividor"></div>

        <div class="chart-section pointer" style="flex: 9;" @click="showRediness = 'managing_directors'" v-if="companyData.company_type == 'corporate'">
            <div class="wrapper-icon">
                <img src="@/assets/arrow_1.svg" class="arrow">
            </div>
            <div class="element-ch">
                <apexchart class="chart-element" type="donut" :options="getOptions('md').options" :series="mdSeries"></apexchart>
                <div class="section-description">
                    <div class="section-title">Managing Directors Section Progress</div>
                    <div class="section-details"><span class="counts counts-color">{{ ManagingDirectorsCheck.filled }} / {{ ManagingDirectorsCheck.needed }}</span> documents complete</div>
                </div>
            </div>
        </div>
        <PopupCover 
            class="detailed-breakdown"
            v-if="showRediness " @close="showRediness = ''"
            >
            <PopupBody 
                @close="() => showRediness = ''"> 
                <template #header>
                    <span v-if="companyData.company_type == 'corporate'">
                        <text v-if="showRediness != 'corporate' ">
                            {{ `Corporate ${showRediness == 'shareholders' ? 'Shareholder': 'Managing Directors'} Progress ${companyData.name.new_value || companyData.name.value}` }}
                        </text>
                        <text v-else>
                            {{ `Corporate Section Progress for ${companyData.name.new_value || companyData.name.value}` }}
                        </text>
                    </span>
                    <span v-else>
                        {{ `Account Holder Section Progress for ${companyData.first_name.new_value || companyData.first_name.value} ${companyData.last_name.new_value || companyData.last_name.value}` }}
                    </span>
                </template>
                <template #body>
                    <div class="flex body-popup column gap-10">
                        <div class="summary-progress">
                            <div class="summary-item">
                                <div class="icon-wrapper missing">
                                    <img src="@/assets/missing.svg">
                                </div>
                                <div class="summary-data">{{ missing_components.length }} blocking items</div>
                            </div>
                            <div class="dividor"></div>
                            <div class="summary-item">
                                <div class="icon-wrapper partial">
                                    <img src="@/assets/partial.svg">
                                </div>
                                <div class="summary-data">{{ partial_components.length }} partially complete</div>
                            </div>
                            <div class="dividor"></div>
                            <div class="summary-item">
                                <div class="icon-wrapper complete">
                                    <img src="@/assets/checkmark.svg">
                                </div>
                                <div class="summary-data">{{ complete_components.length }} complete</div>
                            </div>
                        </div>

                        <div class="section-info" v-if="missing_components.length > 0">
                            <div class="summary-item align-center">
                                <div class="icon-wrapper missing">
                                    <img src="@/assets/missing.svg">
                                </div>
                                <div class="summary-data"><b>Missing items ({{ missing_components.length }})</b></div>
                            </div>
                            <div class="horizontal-dividor"></div>
                            <div class="row-holder flex column gap-20">
                                <div class='info-holder' v-for="item of missing_components" :key="item.name">
                                    <div class="flex column text-left gap-5px">
                                        
                                        <div class="flex row gap-10">
                                            <div class="w-full flex row gap-10px align-center">
                                                <div class="icon-wrapper missing">
                                                    <img src="@/assets/missing.svg">
                                                </div>
                                                <p class="requirements text-info">{{ item.name }}: </p>
                                                <div class='take-a-look' @click="scrollTo(item, showRediness)">
                                                    Go to section 
                                                    <img src="@/assets/arrow-breadcrumb.svg" class="arrow-go-tosection">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="req-info flex wrap row red requirements text-info bold" v-if="item?.missing?.length > 0">
                                            <span class="netral"> Missing: </span>
                                            <span v-for="i in item.missing" >
                                                {{ Utils.fieldToName(i, item) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <div class="section-info" v-if="partial_components.length > 0">
                            <div class="summary-item ">
                                <div class="icon-wrapper partial">
                                    <img src="@/assets/partial.svg">
                                </div>
                                <div class="summary-data">Partially complete ({{ partial_components.length }})</div>
                            </div>
                            <div class="horizontal-dividor"></div>
                            <div class="row-holder flex column gap-20">
                                <div class='info-holder' v-for="item of partial_components" :key="item.name">
                                    <div class="flex column text-left gap-5px">

                                        <div class="flex row gap-10">
                                            <div class="w-full flex row gap-10px align-center">
                                                <div class="icon-wrapper partial">
                                                    <img src="@/assets/partial.svg">
                                                </div>
                                                <p class="requirements text-info">{{ item.name }}: </p>
                                                <div class='take-a-look' @click="scrollTo(item, showRediness)">
                                                    Go to Section
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex row space-between" v-if="item?.filledDocuments > 0">
                                            <div class="req-info flex wrap row red requirements text-info bold" v-if="item?.missing?.length > 0">
                                                <span> Missing the following: </span>
                                                <span v-for="i in item.missing" >
                                                    {{ Utils.fieldToName(i, item) }}
                                                </span>
                                            </div>
                                            <ProgressBar 
                                                class='progress-bar-partial' 
                                                :slim="true" 
                                                :current="item.filledDocuments" 
                                                :total="item.needed" 
                                                :percentage_outside="true"    
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="section-info" v-if="complete_components.length > 0">
                            <div class="summary-item">
                                <div class="icon-wrapper complete">
                                    <img src="@/assets/checkmark.svg">
                                </div>
                                <div class="summary-data">Completed ({{ complete_components.length }})</div>
                            </div>

                            <div class="horizontal-dividor"></div>

                            <div class="row-holder flex column gap-20">
                                <div class='info-holder' v-for="item of complete_components" :key="item.name">
                                    <div class="flex column text-left">
                                        <div class="flex row gap-10">
                                            <div class="w-full flex row gap-10px align-center">
                                                <div class="icon-wrapper complete">
                                                    <img src="@/assets/checkmark.svg">
                                                </div>
                                                <p class="requirements text-info">{{ item.name }}: </p>
                                                <div class='take-a-look' @click="scrollTo(item, showRediness)">
                                                    Go to Section
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </PopupBody>
        
        </PopupCover>
    </div>
</template>

<script setup>

import { ref, defineEmits, onMounted, computed } from 'vue' 
import ProgressBar from './ProgressBar.vue';
import PopupCover from './PopupCover.vue';
import PopupBody from './PopupBody.vue';
import { useStore } from 'vuex'
import Utils from '@/utils';


import { useRouter } from 'vue-router'

const router = useRouter();
const store = useStore()


const corporateFiles = computed(() => store.getters.getCorporateFilesReadiness)
const companyData = computed(() => store.state.companyData)
const fileMap = computed(() => store.getters.getFilesMapID)
const shareHolderStructure = computed(() => store.getters.getStructureForChart({
    type: 'shareholder', 
    root: true,
    full: true
}));

const MDStructure = computed(() => store.getters.getStructureForChart({
    type: 'entity', 
    source: 'entity',
    root: true,
    full: true
}));





const showRediness = ref(false)

const person = computed(() => {
    return store.state.kyc_persons;
})


const getTitle = computed(() => {
    let title = 'Shareholders Section Progress';
    if (companyData.value.company_type == 'account_holder') {
        title = 'Account Holder Section Progress';
    }
    return title;

})

const generalSection = computed( () => {
    let needed = filledDocsGeneral.value.needed_docs;
    let current = filledDocsGeneral.value.filledDocuments;

    let part = 100 / needed;
    let filled = part * current;
    let rest = 100 - filled

    return [filled, rest]
})

const mdSeries = computed( () => {
    let needed = ManagingDirectorsCheck.value.needed;
    let current = ManagingDirectorsCheck.value.filled;

    let part = 100 / needed;
    let filled = part * current;
    let rest = 100 - filled

    return [filled, rest]
})

const shareholderSeries = computed( () => {
    let needed = initShareholderCheck.value.needed;
    let current = initShareholderCheck.value.filled;

    let part = 100 / needed;
    let filled = part * current;
    let rest = 100 - filled

    return [filled, rest]
})

const components = computed( () => {
    if (showRediness.value == 'shareholders') {
        return initShareholderCheck.value.components
    } else if (showRediness.value == 'corporate') {
        return Object.values(filledDocsGeneral.value.components).filter(el => el.needed > 0)
    } else if (showRediness.value == 'managing_directors') {
        return ManagingDirectorsCheck.value.components
    }
})



const missing_components = computed(() => {
    return components.value.filter( item => (item?.missing?.length > 0 && item?.needed == item?.missing?.length) || item?.filledDocuments == 0)
})
const partial_components = computed(() => {
    return components.value.filter( item => item?.missing?.length > 0 && item?.missing.length > 0 && item.filledDocuments > 0)
})
const complete_components = computed(() => {
    return components.value.filter( item => item?.missing?.length == 0)
})

const total_documents_needed = computed(() => {
    let total = initShareholderCheck.value.needed;
    if (companyData.value.company_type == 'corporate') {
        total += filledDocsGeneral.value.needed_docs + ManagingDirectorsCheck.value.needed;
    }
    return total;
})
const total_documents_filled = computed(() => {
    let total = initShareholderCheck.value.filled
    console.log('total md', companyData.value.company_type)
    if (companyData.value.company_type == 'corporate') {
        total += filledDocsGeneral.value.filledDocuments + ManagingDirectorsCheck.value.filled;
    }
    return total;
})

const getOptions = computed(() => (type) => {
    const chartDef = {
        series: [30, 70],

        options: {
            chart: {
                type: "donut",
                redrawOnWindowResize: true,
                redrawOnParentResize: true
            },
            plotOptions: {
                pie: {
                    startAngle: -120,
                    endAngle: 120,
                    donut: {
                        size: "80%",
                    },
                },
            },
            stroke: {
                show: false,
            },
            dataLabels: {
                enabled: false, // Hide default labels
            },
            legend: {
                show: false,
            },
            colors: ["#0073EF", "#EAEAEA"], // Active + Background color
            labels: ["Completed", "Remaining"], // Labels for the donut chart
            states: {
                hover: {
                    filter: {
                        type: "none",
                    },
                },
            },
            annotations: {
                position: "front",
                texts: [
                    {
                        text: "75%", // Change dynamically if needed
                        x: "50%", 
                        y: "52%",
                        fontSize: "22px",
                        fontWeight: "bold",
                        textAnchor: "middle",
                    },
                ],
            },
            tooltip: {
                theme: "dark", // Options: "dark", "light"
                style: {
                    fontSize: '12px',
                    fontFamily: 'Arial',
                    color: '#fff', // Text color
                },
                fillSeriesColor: false, // Prevents series color from affecting tooltip text
                background: {
                    color: '#333', // Background color
                }
            }
        }
    }
    let progress = null
    if (type == 'general') {
        progress = generalSection.value
    }
    if ( type == 'sh') {
        progress = shareholderSeries.value
    }
    if (type == 'md') {
        progress = mdSeries.value
    }
    chartDef.options.annotations.texts[0].text = +(progress[0]).toFixed(2) + '%'
    return chartDef
})

function checkEntity(accumulator, entity, parent_type) {
    let needed = 0;
    let filledDocuments = 0;
    let fields_to_check = getEntity();
    if (parent_type == 'corporate_shareholder' || entity.supervised.value.toString() == 'false') {
        fields_to_check = fields_to_check.filter( el => el.docType != 'entity_license')
    }
    needed += fields_to_check.length;
    for (let cur of fields_to_check) {
        const file = fileMap.value[entity.files[cur.docType]]
        const res = checkFile(file, cur)
        filledDocuments += res[1] == res[0] ? 1 : 0;
    }
    accumulator.filled += filledDocuments;
    accumulator.needed += needed;

    let typeTitle = parent_type.replace('_', ' ');
    typeTitle = typeTitle.charAt(0).toUpperCase() + typeTitle.slice(1);
    accumulator.components.push({
        id: 'id' + entity._id,
        type: 'entity',
        name: typeTitle + ' ' + entity.name.value,
        filledDocuments,
        needed
    })
}

function scrollTo(item) {
    let dictToScroll = {
        'shareholders': companyData.value.company_type == 'corporate' ? 'shareholders' : 'account-holder',
        'corporate': 'corporate',
        'managing_directors': 'managing-directors',
    }

    const elementId = store.getters.getFileId(item.documentType);
    router.push(`/kyc/${companyData.value._id}/${dictToScroll[showRediness.value]}/?highlight=id${elementId}`)
    showRediness.value = '';

}

function checkPerson({
        accumulator, 
        person, 
        type = 'UBO', 
        withComponents = false
    }) {
    let needed = 0;
    let filledDocuments = 0;
    let fields_to_check = getPerson();


    if (type == 'Official') {
        fields_to_check = fields_to_check.filter( el => ![
            'source_of_funds', 
            'source_of_wealth'
        ].includes(el.docType))
    }
    if (person.location_type.value == 'local') {
        fields_to_check = fields_to_check.filter( el => el.docType != 'secondPassport_file')
    } 
    needed += fields_to_check.length;

    for (let cur of fields_to_check) {
        const file = fileMap.value[person.files[cur.docType]]
        let result = checkFile(file, cur, person)
        filledDocuments += result[1] == result[0] ? 1 : 0;
        if (withComponents) {
            accumulator.components.push({
                id: 'id' + file.id,
                needed: result[0],
                documentType: cur.docType,
                filledDocuments: result[1],
                missing: result[2],
                name: Utils.typeToName(cur.docType) || cur.docType,
            })
        }
    }
    accumulator.filled += filledDocuments;
    accumulator.needed += needed;
    if (!withComponents) {
        accumulator.components.push({
            id: 'id' + person._id,
            type: 'person',
            name: type + ' ' + person?.firstName?.value + ' ' + person?.lastName?.value,
            filledDocuments,
            needed
        })
    }

}


function checkCorporate(accumulator, corporate) {
    let managingDirectors = corporate.children.filter( el => el.type == 'corporate');
    let shareholders = corporate.children.filter( el => el.type == 'shareholder');
    let officials = corporate.children.filter( el => el.type == 'official');
    let entity = corporate.entity;
    
    if (corporate.entity_type == 'entity' || corporate.type == 'corporate_shareholder') {
        checkEntity(accumulator, entity, corporate.type);
    }
    for (let managingDirector of managingDirectors) {
        checkCorporate(accumulator, managingDirector);
    }
    for (let shareholder of shareholders) {
        calculateShareholderNeededFiles(accumulator, shareholder);
    }
    for (let official of officials) {
        checkPerson({
            accumulator, 
            person: {
                ...official,
                location_type: { value: corporate.location_type.value },
            }, 
            type:'Official'
        });
    }
    if (corporate.entity_type == 'person' && corporate.type == 'corporate') {
        if (officials.length == 0) {
            let fields_to_check = getPerson();
            accumulator.needed += fields_to_check.length;
            accumulator.components.push({
                name: `Missing At least one Official for managing dirrector Section`,
                filledDocuments: 0,
                needed: fields_to_check.length,
            })
        }
    }
    if (corporate.type == 'corporate_shareholder') {
        if (managingDirectors.length == 0) {
            let fields_to_check = getPerson();
            accumulator.needed += fields_to_check.length;
            accumulator.components.push({
                id: `id-md${corporate._id}`,
                name: `Missing At least one Managing Director Section for ${entity.name.value}`,
                filledDocuments: 0,
                needed: fields_to_check.length,
            })
        }
    }
    if (corporate.type == 'corporate') {
        //check number of officials if none add missing
        let officials = corporate.children.filter( el => el.type == 'official');
        if (officials.length == 0) {
            let fields_to_check_number = getPerson().length;

            // officials does not need source of funds and source of wealth
            fields_to_check_number = fields_to_check_number - 2;
            if (corporate.location_type.value == 'local') {
                fields_to_check_number = fields_to_check_number - 1;
            }

            accumulator.needed += fields_to_check_number;
            accumulator.components.push({
                id: `id-officials${corporate._id}`,
                name: `Missing At least one Official for ${entity.name.value}`,
                filledDocuments: 0,
                needed: fields_to_check_number,
            })
        }
    }
    if (
        !(
            (corporate.type == 'corporate' && corporate.entity_type == 'entity' && entity.supervised.value.toString() == 'false') ||
            (corporate.type == 'corporate_shareholder')
        )
    ) {
        return
    }
    if (corporate.location_type.value == 'local') {
        return;
    }



    if (shareholders.length == 0) {
        let fields_to_check = getPerson();
        accumulator.needed += fields_to_check.length;
        accumulator.components.push({
            id: `id-sh-h${corporate._id}`,
            name: `Missing UBO section for ${entity.name.value}`,
            filledDocuments: 0,
            needed: fields_to_check.length,
        })
    } else {
        let totalSharesCovered = 0;
        shareholders.forEach( shareholder => {
            totalSharesCovered += shareholder.percentage_held;
        })
        const remainingShares = 100 - totalSharesCovered;
        if (remainingShares > 0) {
            let fields_to_check = getPerson();
            accumulator.needed += fields_to_check.length;
            accumulator.components.push({
                id: `id-sh-h${corporate._id}`,
                name: `Missing at least one shareholder of ${remainingShares}% for ${entity.name.value}`,
                filledDocuments: 0,
                needed: fields_to_check.length,
            })
        }
    }
}

const ManagingDirectorsCheck = computed(() => {
    let info = {
        needed: 0,
        filled: 0,
        components: []
    }
    let managingDirectors = MDStructure.value[0].children.filter( el => el.type == 'corporate');
    
    for (let managingDirector of managingDirectors) {
        checkCorporate(info, managingDirector)
    }

    if (managingDirectors.length == 0) {
        let fields_to_check = getPerson();
        info.needed += fields_to_check.length;
        info.components.push({
            id: 'md_corporate',
            name: `Missing Managind Director for ${companyData.value.name.value}`,
            filledDocuments: 0,
            needed: fields_to_check.length,
        })
    }
    return info;
})


const initShareholderCheck = computed(() => {
    
    let info = {
        needed: 0,
        filled: 0,
        components: []
    }

    if (companyData.value.company_type == 'account_holder') {
        checkPerson({
            accumulator: info,
            person: person.value[0],
            type: 'UBO', 
            withComponents: true
        });
        return info;
    }

    let shareholders = shareHolderStructure.value[0].children;

    for (let shareholder of shareholders) {
        calculateShareholderNeededFiles(info, shareholder);
    }
    if (shareholders.length == 0) {
        let fields_to_check = getPerson();
        info.needed += fields_to_check.length;
        info.components.push({
            id: `shareholder_corporate`,
            name: `Missing Shareholder for ${companyData.value.name.value}`,
            filledDocuments: 0,
            needed: fields_to_check.length,
        })
    }
    return info;
})


function calculateShareholderNeededFiles(accumulator, shareholder){
    let child = shareholder.children[0];
    if (child.type == 'ubo') {
        checkPerson({
            accumulator, 
            person:child,
            withComponents: true
        });
    } else {
        checkCorporate(accumulator, child);
    }
}

function getEntity() {
    const docs = [
        {docType: 'entity_aoi', file: true},
        {docType: 'entity_coc', file: true},
        {docType: 'entity_members', file: true},
        {docType: 'entity_rodo', file: true},
        {docType: 'entity_soi', file: true},
        {docType: 'entity_license', file: true,},
    ]
    return docs;
}

const getFileId = (type) => {
    return computed(() => store.getters.getFileId(type)).value;
}

function getPerson(){
    const docs = [
        {docType: 'passport_file', file: true, additinal_person_fields: [
            'firstName', 'lastName', 'passportNumber', 'passportCountry', 'dateIssued', 'dateExpiry', 
        ]}, 
        {
            docType: 'address_file',
            file: true, 
            additinal_person_fields: [
               'address_line_1', 'city', 'address_country', 'zip', 
            ],
            additinal_fields: [
                'dateIssued'
            ]
        },
        {docType: 'secondPassport_file', file: true, additinal_person_fields: [
            'secondPassportNumber', 'secondPassportType', 'secondPassportCountry', 'secondDateIssued', 'secondDateExpiry', 
        ]},
        {docType: 'bank_reference_letter', file: true},
        {docType: 'source_of_funds', file: true},
        {docType: 'source_of_wealth', file: true},
        {docType: 'google_search', file: true},
        {docType: 'world_check', file: true},
    ]
    return docs;
}



function checkFile(fileArea, settings, person) {
    let neededCount = 1;
    let filledCount = 0;
    let missing = []
    if(fileArea && fileArea?.file?.filename) {
        filledCount += 1;

    } else {
        missing.push('File')
    }
 
    if (settings.additinal_fields) {
        for(let field of settings.additinal_fields) {
            neededCount += 1;
            if (fileArea[field]) {
                filledCount += 1
            } else {
                missing.push(field)
            }
        }
    }

    if (settings.additinal_person_fields) {
        for(let field of settings.additinal_person_fields) {
            neededCount += 1;
            if (person[field].value) {
                filledCount +=1
            } else {
                missing.push(field)
            }
        }
    }
   
    return [neededCount, filledCount, missing];
   
}


const generalSectionDocs = ref([
    {docType: 'kyc-ma-1', file: true}, 
    {docType: 'kyc-ppa-2', file: true}, 
    {docType: 'kyc-gaming-license', file: true}, 
    {docType: 'kyc-feeibtbvdna-3', file: true,  additinal_fields: ['dateIssued']}, 
    {docType: 'kyc-lteabibtdoea-4', file: true, additinal_fields: ['dateIssued']}, 
    {docType: 'kyc-mlibtdoea-4-1', file: true, additinal_fields: ['dateIssued']}, 
    {docType: 'kyc-aoi-5', file: true}, 
    {docType: 'kyc-attaoi-5-1', file: true, additinal_fields: ['dateIssued']}, 
    {docType: 'kyc-reftcoc-5-2', file: true, additinal_fields: ['dateIssued']}, 
    {docType: 'kyc-oc-6', file: true}, 
    {docType: 'kyc-sr-7', file: true}, 
    {docType: 'kyc-reftcoc-7-1', file: true}, 
    {docType: 'kyc-sof-8', file: true}, 
    {docType: 'kyc-ruling', file: true}, 
    {docType: 'cosbaof', file: true, additinal_fields: ['bank_name']}, 
    {docType: 'scfba', file: true, additinal_fields: ['bank_name']}, 
    {docType: 'kyc-aa-y1-12', file: true, additinal_fields: ['year', 'fiscal_year_ending_on']}, 
    {docType: 'kyc-aa-y2-12', file: true, additinal_fields: ['year', 'fiscal_year_ending_on']},
    {docType: 'kyc-dogmos-13', file: true, additinal_fields: ['year']}, 
    {docType: 'kyc-fpt-14', file: true, additinal_fields: ['year']},
    {docType: 'subsidiaries', file: true, additinal_fields: ['year']},
])


const filledDocsGeneral = computed(() => {

    let components = generalSectionDocs.value.reduce(( acc, cur ) => {
        acc[cur.docType] = { 
            filledDocuments: 0,
            needed: 0, 
            name: Utils.typeToName(cur.docType) || cur.docType, 
            id: 'id' + cur.docType,
            documentType: cur.docType,
            missing: [],
        }
        return acc
    }, {})

    let settingsToCheck = generalSectionDocs.value;
    if (companyData.value?.location_type?.value == 'local') {
        settingsToCheck = settingsToCheck.filter(el => ![
            'kyc-ma-1', 
            'kyc-ppa-2', 
            'kyc-feeibtbvdna-3', 
            'kyc-dogmos-13',
            'kyc-gaming-license',
        ].includes(el.docType))
        delete components['kyc-gaming-license'];
        delete components['kyc-ma-1'];
        delete components['kyc-ppa-2'];
        delete components['kyc-feeibtbvdna-3'];
        delete components['kyc-dogmos-13'];
    }
    let filledDocuments = 0;
    let needed_docs_list = settingsToCheck.filter( el => el.docType != 'subsidiaries');
    let needed_docs = needed_docs_list.length;
    let subsidiariesList = corporateFiles.value.filter( el => el.documentType == 'subsidiaries');
    let subsidiaries = subsidiariesList.length;
    let scfbaList = corporateFiles.value.filter( el => el.documentType == 'scfba')
    let scfba = scfbaList.length;
    let cosbaofList = corporateFiles.value.filter( el => el.documentType == 'cosbaof')
    let cosbaof = cosbaofList.length;

    needed_docs += subsidiaries;
    needed_docs += scfba - 1;
    needed_docs += cosbaof - 1;
    components['subsidiaries'].needed = subsidiaries;
    components['scfba'].needed = scfba;
    components['cosbaof'].needed = cosbaof;
    settingsToCheck.forEach( cur => {
        const fileAreas = corporateFiles.value.filter( file => file.documentType == cur.docType)
        for (let fileArea of fileAreas) {
            
            let result = checkFile(fileArea, cur);
            console.log('result', result)
            filledDocuments += result[0] == result[1] ? 1 : 0;

            // if (result) {
            components[cur.docType].filledDocuments += result[1];
            components[cur.docType].needed += result[0];
            components[cur.docType].missing = result[2];
            // }
        }
    })
    return {
        components: components,
        filledDocuments, 
        needed_docs
    }
})

onMounted(() => {
});

</script>

<style lang="scss" scoped>

    .section-header {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .requirements {
        max-width: 85%;
        font-weight: bold;
        font-size: 14px;
        span {
            color: #9a3535;
            background-color: rgb(255, 215, 215);
            border-radius: 5px;
            padding: 2px 8px;
            margin-right: 10px;
            font-size: 12px;
           
        }
    }
    .shareholder-section {
        position: relative;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        border: 1px solid var(--border-color);
    }

    .detailed-breakdown {
        &:deep(.popup-container) {
            width: 700px;
        }
        p {
            margin: 0;
            font-size: 14px;
        }
    }


    .labels {
        display: flex;
        gap: 10px 
    }
    .holder-label {
        // position: absolute;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 20px;
        width: 280px;
    }
    
    .body-popup {
        max-height: 80vh;
        overflow-y: auto;
        box-sizing: border-box;
        width: 720px;
    }
    h3 {

        font-size: 14px;
        margin-top: 0;
        text-align: left;
    }
    .chart-container {
        position: relative;
        // flex-direction: row;

        align-items: stretch;

        &.account_holder {
            width: 361px;
        }
    }
    .progress-bar-partial {
        min-width: 150px;
        &:deep(.progress-bar .progress-bar-fill) {
            background-color: #F9A802;
        }

    }
    .shareholder-section {
        background: white;
    }
    .tip {
        width: 40px;
        height: 20px;
    }

    .take-a-look {
        // width: 20px;
        // height: 18px;
        font-size: 12px;
        cursor: pointer;
        margin-left: auto;
        color: black;
        border: 1px solid var(--border-color);
        border-radius: 4px;
        padding: 2px 6px;
        display: flex;
        align-items: center;
        // display: none;
        &:hover {
            color: #0060c6;
        }
    }

 
    canvas {
        width: 400px;
        height: 400px;
        max-height: 400px;
        max-width: 400px;
    }
  
    .bg-white {
        background-color: white;
        border: 1px solid var(--border-color);
        border-radius: 5px;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        min-height: 100px;
        position: relative;
    }
    .element-ch {
        box-sizing: border-box;
        display: flex;
        height: 100%;

        flex-direction: column;
        justify-content: space-between;
    }
    .red {
        color: red
    }
    .completion-rate-info {
        font-size: 20px;
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
        .info-text {
            font-size: 16px;
            color: var(--text-secondary-color);
        }
    }
    .chart-element {
        max-width: 200px;
        max-height: 200px;
        margin: 0 auto;
    }
    .section-title {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
    }
    .dividor {
        width: 1px;
        background-color: var(--border-color);
        margin: 10px;
        
    }
    .section-description {
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: center;
        z-index: 10;
        margin-top: -60px;
        background-color: white;
    }
    .counts {
        font-size: 15px;
        font-weight: bold;
    }

    .counts-color {
        color: rgb(0 115 239 / 71%);
    }
    
    .chart-section {
        position: relative;
        &:hover {
            .wrapper-icon {
                background: rgb(236, 244, 255);
            }
        }
    }

    .wrapper-icon {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 35px;
        height: 35px;
        z-index: 10;
        display: flex;
        border-radius: 5px;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);

        img {
            width: 20px;
            height: 20px;
            transform: rotateZ(45deg);
        }
    }

    .summary-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
       
    }
    .arrow-go-tosection {
        width: 12px;
        height: 12px;
    }
    .icon-wrapper {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        &.missing {
            background-color: #9a3535;
        }
        &.partial {
            background-color: #F9A802;
        }
        &.complete {
            background-color: #519d51;
        }
        img {
            width: 12px;
            height: 12px;
        }
    }
    .summary-progress {
        display: flex;
        gap: 10px;
        margin: 1px;
        margin-bottom: 20px;
        background-color: white;
        box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
        // box-shadow: 0px 0px 1.5px 0px #BB3530;
        width: calc(100% - 20px);
        padding: 10px;
        border-radius: 5px;
        box-sizing: border-box;
    }
    .dividor {
        width: 1px;
        background-color: var(--border-color);
        margin: 0 5px;
    }
    .section-info {
        background-color: white;
        box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
        border-radius: 5px;
        padding: 10px;
        width: calc(100% - 20px);
        box-sizing: border-box;
        margin: 1px;
    }
    .horizontal-dividor {
        height: 1px;
        background-color: var(--border-color);
        margin: 10px 0;
    }
    .req-info {
        padding-left: 30px;
        gap: 5px;
    }
    
</style>